import { authenticatedJsonFetch } from '@perpay-web/authentication/authenticatedJsonFetch';
import { HTTPMethod } from '@perpay-web/constants/httpMethods';
import { USER_ENDPOINT } from '@perpay-web/constants/urls';
import { getData, useDataModule } from '@perpay-web/data-module/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import {
    checkoutUpdateUserInformation,
    checkoutUpdateUserInformationError,
    checkoutUpdateUserInformationReset,
    checkoutUpdateUserInformationSuccess,
} from '@perpay-web/hooks/actions/checkoutUpdateUserInformation';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const getUserInformation = (state) => getData(state) || {};

const getSsnIsVerified = (state) =>
    getUserInformation(state).ssnIsVerified || false;

const getSsnVerificationAttempts = (state) =>
    getUserInformation(state).ssnVerificationAttempts || 0;

export const getUserHasFailedIDV = (state) => {
    const ssnIsVerified = getSsnIsVerified(state);
    const ssnVerificationAttempts = getSsnVerificationAttempts(state);
    return !ssnIsVerified && ssnVerificationAttempts > 0;
};

const useCheckoutUpdateUserInformation = () => {
    const dataModule = useDataModule((payload) =>
        authenticatedJsonFetch(USER_ENDPOINT, payload, HTTPMethod.patch),
    );

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: checkoutUpdateUserInformation,
        error: checkoutUpdateUserInformationError,
        success: checkoutUpdateUserInformationSuccess,
        reset: checkoutUpdateUserInformationReset,
    });

    return dataModule;
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = useCheckoutUpdateUserInformation();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    UseCheckoutUpdateUserInformationDataModuleProvider,
    useCheckoutUpdateUserInformationContext,
] = createContextProvider(providerFactory);
